(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (!window.customElements || window.customElements.get('newsletter-popup')) return;

    var KEY_SUBSCRIBED = 'trNlSubscribed'; // localStorage '1': this browser subscribed via ANY newsletter form
    var KEY_PENDING = 'trNlPending'; // sessionStorage '1': THIS popup's form was just posted
    var KEY_SHOWN = 'trNlShown'; // sessionStorage '1': already shown this browser session ("Every visit")
    var KEY_LAST = 'trNlLastShown'; // localStorage ms timestamp: last shown/closed (day frequencies)
    var DAY_MS = 86400000;
    // <input> types that aren't typed into: picking a variant / filter / sort option isn't "filling in a form".
    var NOT_TYPED = /^(checkbox|radio|range|color|file|button|submit|reset|image|hidden)$/i;
    var claimed = false; // only one popup instance may auto-open per page view

    // Every Web Storage access is wrapped: even reading window.localStorage throws when storage is blocked.
    function store(type) {
      return {
        get: function (key) {
          try { return window[type].getItem(key); } catch (e) { return null; }
        },
        set: function (key, value) {
          try { window[type].setItem(key, value); return true; } catch (e) { return false; }
        },
        remove: function (key) {
          try { window[type].removeItem(key); } catch (e) { /* storage unavailable */ }
        },
        usable: function () {
          try { window[type].setItem('trNlProbe', '1'); window[type].removeItem('trNlProbe'); return true; } catch (e) { return false; }
        }
      };
    }
    var local = store('localStorage');
    var session = store('sessionStorage');

    // Rewrite the address bar without a reload or a new history entry.
    function replaceUrl(search, hash) {
      try { window.history.replaceState(window.history.state, '', window.location.pathname + search + hash); } catch (e) { /* keep the URL */ }
    }
    // `search` minus every customer_posted=true, keeping the other parameters exactly as they were.
    function withoutPosted(search) {
      var s = search.replace(/[?&]customer_posted=true(?=&|$)/g, '');
      return s.charAt(0) === '&' ? '?' + s.slice(1) : s;
    }
    // After a real form post Shopify redirects back to the page the form was on, so the referrer is this site.
    function sameOriginReferrer() {
      try { return !!document.referrer && new URL(document.referrer).origin === window.location.origin; } catch (e) { return false; }
    }

    // ES5-syntax custom element: Shopify minifies the section JS bundle as ES5, which rejects `class`.
    function NewsletterPopup() { return Reflect.construct(HTMLElement, [], NewsletterPopup); }
    NewsletterPopup.prototype = Object.create(HTMLElement.prototype);
    NewsletterPopup.prototype.constructor = NewsletterPopup;
    Object.setPrototypeOf(NewsletterPopup, HTMLElement);
    var proto = NewsletterPopup.prototype;

    proto.connectedCallback = function () {
      var self = this;
      var dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return; // no native dialog: stays hidden
      this.dialog = dialog;
      this._live = false; // true only on the storefront (not the editor / section-picker preview)
      this._modal = false;
      this._ac = new AbortController();
      var opts = { signal: this._ac.signal };

      Array.prototype.forEach.call(this.querySelectorAll('[data-nlp-close]'), function (btn) {
        btn.addEventListener('click', function () { self.close(); }, opts);
      });
      // Backdrop click = a press that starts AND ends outside the card (a text-selection drag never closes it).
      dialog.addEventListener('pointerdown', function (e) { self._pressOnBackdrop = self._isBackdrop(e); }, opts);
      dialog.addEventListener('click', function (e) {
        if (self._pressOnBackdrop && self._isBackdrop(e)) self.close();
        self._pressOnBackdrop = false;
      }, opts);
      dialog.addEventListener('close', function () { self._afterClose(); }, opts);

      if (dialog.classList.contains('nlp-dialog--preview')) return; // editor section-picker thumbnail
      if (this._inEditor()) { this._bindEditor(opts); return; }

      this._live = true;
      var form = this.querySelector('form');
      if (form) form.addEventListener('submit', function () { session.set(KEY_PENDING, '1'); }, opts);
      // On demand: any link ending in #newsletter (e.g. the footer's "Newsletter" -> /#newsletter) opens it here,
      // whatever the frequency setting, instead of navigating.
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a || !/#newsletter$/.test(a.getAttribute('href') || '')) return;
        e.preventDefault();
        self.open();
      }, opts);
      // Back/forward cache: a restored page resumes its paused timer, so re-check everything when it comes back.
      window.addEventListener('pageshow', function (e) { if (e.persisted) self._onRestore(); }, opts);
      this._boot();
    };

    proto.disconnectedCallback = function () {
      if (this._ac) this._ac.abort();
      clearTimeout(this._timer);
    };

    proto._inEditor = function () {
      return this.hasAttribute('data-design-mode') || !!(window.Shopify && window.Shopify.designMode);
    };

    // Theme editor: never auto-open. Show it while the section is selected, including after each settings
    // re-render (shopify:section:load, and select with detail.load = true). Never showModal()/show()/focus()
    // here: each of those pulls keyboard focus out of the editor sidebar into the preview, so the client
    // would lose her cursor every time the preview refreshes while she types. The open attribute alone doesn't.
    proto._bindEditor = function (opts) {
      var self = this;
      var id = this.getAttribute('data-section-id');
      var mine = function (e) { return !!(e.detail && e.detail.sectionId === id); };
      var show = function (e) { if (mine(e)) self._preview(); };
      document.addEventListener('shopify:section:select', show, opts);
      document.addEventListener('shopify:section:load', show, opts);
      document.addEventListener('shopify:section:deselect', function (e) { if (mine(e)) self.close(); }, opts);
    };

    proto._preview = function () {
      var dialog = this.dialog;
      if (!dialog || dialog.open) return;
      this._preloadImages();
      dialog.classList.add('nlp-dialog--editor');
      dialog.setAttribute('open', '');
    };

    proto._subscribed = function () {
      return this.hasAttribute('data-customer-subscribed') || local.get(KEY_SUBSCRIBED) === '1';
    };

    // The auto-open rules. Checked at load and again right before opening.
    proto._mayAutoOpen = function () {
      return !this._subscribed() && this._isDue();
    };

    proto._boot = function () {
      // hCaptcha /challenge page: keep trNlPending for the redirect back to the real page.
      if (/^\/challenge/.test(window.location.pathname)) return;

      var posted = /(?:^|[?&])customer_posted=true(?:&|$)/.test(window.location.search);
      var pending = session.get(KEY_PENDING) === '1';
      if (pending) session.remove(KEY_PENDING);
      if (posted) {
        // customer_posted=true is only a URL flag: a link copied from the address bar carries it too. It means
        // "this browser subscribed" only straight after a real post: this form's own submit, or a newsletter
        // form elsewhere on this site (the redirect keeps that page as the referrer). Then never nag again.
        if (pending || sameOriginReferrer()) local.set(KEY_SUBSCRIBED, '1');
        // Out of the address bar, so it can't be bookmarked or shared (the page itself is already rendered).
        replaceUrl(withoutPosted(window.location.search), window.location.hash);
      }

      var ok = this.querySelector('[data-nlp-success]');
      var errors = this.querySelector('[data-nlp-errors]');
      var email = this.querySelector('input[type="email"]');

      // The reload after THIS form posted: show its server-rendered result straight away.
      if (pending && ((posted && ok) || errors)) {
        claimed = true;
        this._showResult(ok || email);
        return;
      }
      // Errors from a different customer form on this page aren't ours to show.
      if (errors) {
        errors.remove();
        if (email) {
          email.removeAttribute('aria-invalid');
          email.removeAttribute('aria-describedby');
          email.value = '';
        }
      }

      if (claimed || ok) return;
      // Arrived via a #newsletter link from another page: open straight away, then tidy the address bar.
      if (window.location.hash === '#newsletter') {
        replaceUrl(window.location.search, '');
        claimed = true;
        this.open();
        return;
      }
      if (!this._mayAutoOpen()) return;
      claimed = true;
      this._schedule();
    };

    // Restored from the back/forward cache. A pending auto-open is re-checked when its timer fires anyway; here,
    // also close the popup if the visitor has subscribed since (e.g. through it, then pressed Back).
    proto._onRestore = function () {
      if (this._subscribed()) {
        clearTimeout(this._timer);
        this.close();
      } else if (!this._isDue() && !this.dialog.open) {
        clearTimeout(this._timer);
      }
    };

    // Open on the result of this form's own post, with focus on it (success note / the field in error).
    proto._showResult = function (target) {
      var self = this;
      var form = this.querySelector('form');
      // The redirect inherits the form action's #fragment. Once the browser processes it, focus moves to that
      // non-focusable form, i.e. out of the dialog. Drop it while the page is still parsing...
      if (form && form.id && window.location.hash === '#' + form.id) replaceUrl(window.location.search, '');
      this.open(target);
      // ...and if focus still got knocked back to the page, put it back once loading has settled.
      var refocus = function () {
        var active = document.activeElement;
        if (target && self.dialog.open && (!active || active === document.body)) target.focus();
      };
      var settle = function () { setTimeout(refocus, 50); };
      if (document.readyState === 'complete') settle();
      else window.addEventListener('load', settle, { once: true, signal: this._ac.signal });
    };

    proto._isDue = function () {
      var freq = this.getAttribute('data-frequency') || 'session';
      // If we can't remember that it was shown (storage blocked), don't show it at all rather than on every page.
      if (freq === 'session') return session.usable() && session.get(KEY_SHOWN) !== '1';
      if (!local.usable()) return false;
      var days = parseInt(freq, 10) || 1;
      var last = parseInt(local.get(KEY_LAST), 10) || 0;
      var now = Date.now();
      return last <= 0 || last > now || now - last >= days * DAY_MS;
    };

    proto._schedule = function () {
      var self = this;
      var opts = { signal: this._ac.signal };
      var seconds = parseFloat(this.getAttribute('data-delay'));
      var delay = (isNaN(seconds) ? 6 : Math.min(Math.max(seconds, 0), 30)) * 1000;
      // A field the visitor types into (outside the popup): text-like inputs, textareas, contenteditable.
      var isTextField = function (el) {
        if (!el || self.contains(el)) return false;
        if (el.isContentEditable || el.tagName === 'TEXTAREA') return true;
        return el.tagName === 'INPUT' && !NOT_TYPED.test(el.type);
      };
      // Never interrupt someone filling in a form: once they've TYPED into a field on this page, it waits for the
      // next page. Clicking a variant radio, a filter checkbox or the sort select doesn't count.
      var engaged = false;
      document.addEventListener('input', function (e) { if (isTextField(e.target)) engaged = true; }, { capture: true, signal: this._ac.signal });
      var attempt = function () {
        if (!self.isConnected || engaged) return;
        // Re-check the rules: since this page loaded the visitor may have subscribed (another tab) or seen it
        // (another page, then Back restored this one from the back/forward cache).
        if (!self._mayAutoOpen()) return;
        if (document.hidden) {
          // Background tab: wait until the visitor is actually looking.
          document.addEventListener('visibilitychange', function onVisible() {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVisible);
            self._timer = setTimeout(attempt, 1000);
          }, opts);
          return;
        }
        // Another overlay (cart drawer, mobile menu, a dialog) is up, or the cursor is in a text field: try again shortly.
        if (document.querySelector('dialog[open], cart-drawer[open], mobile-nav[open]') || isTextField(document.activeElement)) {
          self._timer = setTimeout(attempt, 2000);
          return;
        }
        self.open();
      };
      this._preloadImages();
      this._timer = setTimeout(attempt, delay);
    };

    // The avatar is lazy (inside a closed dialog it would never load), so fetch it once the popup is due.
    proto._preloadImages = function () {
      Array.prototype.forEach.call(this.querySelectorAll('img[loading="lazy"]'), function (img) { img.loading = 'eager'; });
    };

    proto.open = function (focusTarget) {
      var dialog = this.dialog;
      if (!dialog || !this.isConnected) return;
      if (dialog.open) {
        if (this._modal) return;
        dialog.close(); // shown non-modally by something else: re-show it as a proper modal
      }
      this._returnFocus = document.activeElement;
      this._preloadImages();
      try { dialog.showModal(); } catch (e) { return; }
      this._modal = true;
      // Land on a submission's outcome (success note / the field in error), else on the heading: it's
      // announced with the dialog and avoids a stray focus ring on the X. No heading = native focus (the X).
      var target = focusTarget || this.querySelector('.nlp-title');
      if (target) target.focus();
      if (this._live) {
        session.set(KEY_SHOWN, '1');
        local.set(KEY_LAST, String(Date.now()));
      }
    };

    proto.close = function () {
      if (this.dialog && this.dialog.open) this.dialog.close();
    };

    // Runs for every close (X, backdrop, Esc, editor deselect). The close event is queued, so skip it if the
    // dialog has already been re-opened in the meantime.
    proto._afterClose = function () {
      if (this.dialog.open) return;
      this._modal = false;
      if (this._live) local.set(KEY_LAST, String(Date.now()));
      var back = this._returnFocus;
      this._returnFocus = null;
      if (back && back !== document.body && back.isConnected && typeof back.focus === 'function') {
        try { back.focus({ preventScroll: true }); } catch (e) { /* no longer focusable */ }
      }
    };

    proto._isBackdrop = function (e) {
      if (e.target !== this.dialog) return false;
      var r = this.dialog.getBoundingClientRect();
      return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    };

    window.customElements.define('newsletter-popup', NewsletterPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
